import React, { FunctionComponent } from 'react'
import { View } from 'react-native'

import { isString } from 'lodash-es'
import { FlattenSimpleInterpolation } from 'styled-components'
import styled, { useTheme } from 'styled-components/native'

import { Divider } from '../../atoms/divider/Divider'
import { ThemeType } from '../../utils'

export type ListItemProps = {
  height?: string | number
  dividerWidth?: string | number
  backgroundColor?: string
  showDivider?: boolean
  dividerColor?: string
  listItemStyle?: FlattenSimpleInterpolation
}

const ListItemContainer = styled.View<{
  height?: string | number
  styles?: FlattenSimpleInterpolation
}>`
  ${({ height }) => height !== undefined && `height: ${(height += isString(height) ? '' : 'px')}`};
  flex-direction: row;
  align-items: stretch;
  ${({ styles }) => styles}
`

/**
 * Component that represents an item in a list and provides a divider for separation
 */
export const ListItem: FunctionComponent<ListItemProps> = ({
  children,
  height,
  dividerWidth,
  backgroundColor,
  showDivider = true,
  dividerColor,
  listItemStyle,
}) => {
  const { colors } = useTheme() as ThemeType

  return (
    <View style={{ backgroundColor: backgroundColor || colors.backgroundPrimary }}>
      <ListItemContainer height={height} styles={listItemStyle}>
        {children}
      </ListItemContainer>
      {showDivider && <Divider height={1} width={dividerWidth} color={dividerColor} />}
    </View>
  )
}
